import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from '../../firebase';
import { withPostTestSearchFields } from '../postTestSearch';


export const createNewPostTest = async (testDoc) => {
    const q = collection(db, "postTests");

    try {

        await addDoc(q, {
            ...withPostTestSearchFields(testDoc),
            updatedTime: serverTimestamp(),
            postTime: serverTimestamp(),
        }).then(() => {
            // setUpdatedProfile(true)
            console.log('New Test Created!');
            alert(
                'New Test Created!',
            );
        })
    }
    catch (error) {
        alert(error);
    }

}
